var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`location-badge location-badge--${_vm.type}`},[_c('font-awesome-icon',{staticClass:"mr-8",attrs:{"icon":"store-alt"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }